import { useEffect, useState } from "react";

export const usePersistedState = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    try {
      const json = window.localStorage.getItem(key);
      return json != null ? JSON.parse(json) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // ignore
    }
  }, [key, value]);

  return [value, setValue];
};
